// Renders the small text format used in lib/legal.js
const Inline = ({ text }) => text.split(/(\*\*[^*]+\*\*)/).map((part, i) =>
  part.startsWith("**") ? <strong key={i} className="font-medium text-tinta">{part.slice(2, -2)}</strong> : part);

const cells = (row) => row.split("|").slice(1, -1).map((c) => c.trim());

const Table = ({ rows }) => {
  const [head, ...body] = rows.map(cells);
  return (
    <div className="overflow-x-auto rounded-[8px] border border-linea">
      <table className="w-full text-left text-[14px]">
        <thead className="bg-superficie text-tinta"><tr>{head.map((h) => <th key={h} className="px-3 py-2 font-medium align-top">{h}</th>)}</tr></thead>
        <tbody>{body.map((r) => <tr key={r[0]} className="border-t border-linea">{r.map((c, i) => <td key={i} className="px-3 py-2 align-top text-sec">{c}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
};

const Block = ({ block }) => {
  const lines = block.split("\n");
  if (block.startsWith("## ")) return <h2 className="font-serif text-[24px] leading-tight text-tinta pt-4">{block.slice(3)}</h2>;
  if (block.startsWith("|")) return <Table rows={lines} />;
  if (block.startsWith("- ")) {
    return <ul className="list-disc pl-5 space-y-1.5">{lines.map((l) => <li key={l}><Inline text={l.slice(2)} /></li>)}</ul>;
  }
  if (/^\d+\. /.test(block)) {
    return <ol className="list-decimal pl-5 space-y-1.5">{lines.map((l) => <li key={l}><Inline text={l.replace(/^\d+\. /, "")} /></li>)}</ol>;
  }
  return <p><Inline text={block} /></p>;
};

export const LegalDoc = ({ text, testId }) => (
  <div className="max-w-3xl space-y-4 text-[15px] text-sec leading-relaxed" data-testid={testId}>
    {text.split(/\n\s*\n/).map((b, i) => <Block key={i} block={b.trim()} />)}
  </div>
);
